<!-- =========================================================================================
  File Name: ClientList.vue
  Description: Clients Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div>
    <div id="main-container">

      <div id="algolia-content-container" class="relative clearfix">
        <!-- Filters -->
        <vx-card class="mb-2">
          <h4>Filters</h4>
        </vx-card>

        <vx-card>
          <vs-row class="mb-4">
            <vs-col vs-w="6"></vs-col>
            <vs-col vs-w="6">
              <!-- SEARCH INPUT -->
              <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg mb-4"
                        type="text"
                        placeholder="Search..."
                        size="large"
                        v-model="searchFilters.filters.search"
                        v-on:keyup.enter="fetchClients"
                        v-on:keyup.esc="searchFilters.filters.search = ''"
              />
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col :vs-w="header.width" v-for="(header, index) in headers" :key="index">
              <span style="font-weight: bold;">{{ header.text }}</span>
            </vs-col>
          </vs-row>

          <vs-divider></vs-divider>

          <vs-row v-for="(client) in clients" :key="client.client_id" @click.native="goToClientDetail(client.client_id)" style="cursor: pointer;">
            <vs-col vs-w="2">{{ client.client_id }}</vs-col>
            <vs-col vs-w="2">{{ client.user_id }}</vs-col>
            <vs-col vs-w="4">{{ client.email }}</vs-col>
            <vs-col vs-w="2">{{ client.first_name }}</vs-col>
            <vs-col vs-w="2">{{ client.last_name }}</vs-col>

            <vs-divider></vs-divider>
          </vs-row>

          <!-- PAGINATION -->
          <vs-pagination

            :total="pageCount"
            :max="7"
            :value="searchFilters.pagination.page"
            @input="(val) => { searchFilters.pagination.page = val; fetchClients(); }"
            style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%;"/>
        </vx-card>
      </div>
    </div>


  </div>
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';

  export default {
    data() {
      return {
        models: models,
        isSearchStalled: false,
        currentRefinement: true,

        resultsPerPageOptions: [
          {label: '25', value: 25},
          {label: '50', value: 50},
          {label: '100', value: 100}
        ],
        searchFilters: {
          filters: {
            search: '',
          },
          pagination: {
            total: 0,
            count: 10,
            page: 1,
          },
        },
        clients: [],

        // Filter Sidebar
        clickNotClose: true,

        headers: [
          {
            text: 'Client ID',
            value: 'client_id',
            width: 2
          },
          {
            text: 'User ID',
            value: 'user_id',
            width: 2
          },
          {
            text: 'Email',
            value: 'email',
            width: 4
          },
          {
            text: 'First Name',
            value: 'first_name',
            width: 2
          },
          {
            text: 'Last Name',
            value: 'last_name',
            width: 2
          }
        ]
      }
    },
    mounted() {
      this.fetchClients();
    },
    computed: {
      pageCount() {
        let total = this.searchFilters.pagination.total;
        let perPage = this.searchFilters.pagination.count;
        let pages = Math.floor(total / perPage);
        let plus1 = total % perPage !== 0;
        if (plus1) pages++;
        return pages;
      },

      windowWidth() {
        return this.$store.state.windowWidth
      },

      hasFilters() {
        if (this.searchFilters.filters.search) return true;

        return false;
      },
    },
    methods: {
      isInCart() {
        return false;
      },
      isInWishList() {
        return false;
      },
      clearFilters() {
        this.searchFilters.filters.search = '';
        this.searchFilters.pagination.count = this.resultsPerPageOptions[0].value;
        this.searchFilters.pagination.page = 1;

        this.fetchClients();
      },
      async goToClientDetail(clientId) {
        // just give the UI enough time to close the dialog
        await new Promise(resolve => setTimeout(resolve, 300));
        this.$router.push(`/clients/detail?id=${clientId}`).catch(()=> {});
      },
      async fetchClients() {
        this.$vs.loading();

        this.isSearchStalled = true;

        let clientsObj = await api.fetchClients(this.buildSearchFilters());
        this.clients = clientsObj.clients;
        this.searchFilters.pagination.total = clientsObj.pagination.total;

        this.isSearchStalled = false;

        this.$vs.loading.close();
      },
      buildSearchFilters() {
        return this.searchFilters;
      },
    },
  }

</script>


<style lang="scss">
  #main-container {
    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

